import RecoverStep from "./recover_step";
import {attachSelectableHandler} from "../utils/recover_utils";

const TEMPLATE = 'export-vm-revoke-mount';

export default class RevokeMount extends RecoverStep {

    constructor() {
        super(TEMPLATE);
    }

    open(data, el, fr, previousStep) {
        data.render = { isLoading : false, location: data.recovery.virtualization.location };
        fr.render('revokeMount');
    }


    postRender(data, el, fr) {
        attachSelectableHandler(el,(d) => {
            data.restore.type = d.type;
        });
    }

    transitionBack(data, el, fr) {
        if(data.deviceId !== undefined){
            fr.goTo('locateVirtualization');
        } else {
            delete data.deviceId;
            delete data.recovery.device_id;
            fr.goTo(data.tmp.previousStep);
        }
    }

    transitionRevoke(data, el, fr) {
        data.render = { isLoading : true };
        fr.render('revokeMount');

        $.get('/share/suppress_cifs_share/' + data.share_id, function (response) {
            if (response.ok) {
                if (newestClientOverviewManager) {
                    newestClientOverviewManager.fetchCifsShares();
                }
                switch (data.recovery.virtualization.location) {
                    case 'vm-export':
                    case 'vhd-export':
                    case 'vhdx-export':
                        fr.goTo('setDevice');
                        break;
                    case 'appliance':
                        fr.goTo('setupLocalVm');
                        break;
                    default:
                        show_alert_2(response['dialogTitle'], response['dialogMsg']);
                        fr.close();
                        break;
                }
            }
        });
    }

}
